import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Alert, AlertDescription, AlertTitle } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const ImportProcessInfoBanner: React.FC = () => {
  return (
    <Box paddingBottom="s16">
      <Alert variant="info">
        <AlertTitle>
          {i18n.t('universal_importer.import_history_process.info_banner.title')}
        </AlertTitle>
        <AlertDescription>
          {i18n.t('universal_importer.import_history_process.info_banner.description')}
        </AlertDescription>
      </Alert>
    </Box>
  )
}
